import cfscript from "refractor/cfscript";
export default cfscript;